"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { DataBuilderContext } from './use-data-builder.mjs';

const FIELDS_TO_SHOW = 5;
const EMPTY_ERROR_FIELDS_LOCATORS = [];
const EMPTY_FROZEN_FIELDS_LOCATORS = [];
const EMPTY_EDITABLE_VARIABLES_SCHEMA_LOCATORS = [];
const DataBuilderProvider = ({
  topLevelField,
  isAdminMode = false,
  children,
  errorFieldsLocators = EMPTY_ERROR_FIELDS_LOCATORS,
  frozenFieldsLocators = EMPTY_FROZEN_FIELDS_LOCATORS,
  editableVariablesSchemaLocators = EMPTY_EDITABLE_VARIABLES_SCHEMA_LOCATORS,
  onAddVariable,
  readOnly = false,
  showNullValueFields = false,
  hideReadOnlyFields = false,
  collapsedDataBuilder = false,
  initialVisibleFieldCount = FIELDS_TO_SHOW
}) => {
  return /* @__PURE__ */ jsx(
    DataBuilderContext.Provider,
    {
      value: {
        topLevelField,
        isAdminMode,
        isReadOnly: readOnly,
        errorFieldsLocators,
        frozenFieldsLocators,
        showNullValueFields,
        hideReadOnlyFields: !!hideReadOnlyFields,
        editableVariablesSchemaLocators,
        onAddVariable,
        initialVisibleFieldCount,
        collapsedDataBuilder
      },
      children
    }
  );
};

export { DataBuilderProvider };
